import { Component, OnInit, Input } from '@angular/core';
import { OrderDocumentHistory } from '../../models/order-document-history.model';
import { OrderService } from '../../services/order.service';

@Component({
  selector: 'app-order-document-history',
  templateUrl: './order-document-history.component.html',
  styleUrls: ['./order-document-history.component.scss']
})
export class OrderDocumentHistoryComponent implements OnInit {
  @Input() orderId: string;
  @Input() line: number;
  @Input() index: number;
  history: OrderDocumentHistory[];
  constructor(private orderService: OrderService) {
  }

  ngOnInit() {
    this.getHistory();
  }
  getHistory() {
    this.orderService.historyDocument(this.orderId, this.line, this.index).subscribe(val => {
      this.history = val;
    });
  }
}
